import { LogsAPI } from '../api/LogsAPI';

export const LogsRepository = {
  saveLogs: (contextData, logsData) => LogsAPI.save(contextData, logsData)
};